<template lang="pug">
	
	.intro-presentation

		//- .gradient-layer
		//- background(ref='background')

		.intro-presentation-wrapper.movable

			.intro-presentation-text(ref="presentaiont_text")

				p.sentence
					<span class='mask-right'/>
					<span class='mask-left'/>
					| «JE SUIS POUR QUE TOUT UN TAS DE PRÉSIDENTS 
				p.sentence
					<span class='mask-right'/>
					<span class='mask-left'/>
					| MORTS* ME REPRÉSENTENT... PARCE QUE JE N'AI JAMAIS 
				p.sentence
					<span class='mask-right'/>
					<span class='mask-left'/>
					| VU UN PRÉSIDENT LE FAIRE DE SON VIVANT.»

				.separator

				p.sentence
					<span class='mask-right'/>
					<span class='mask-left'/>
					| *dead presidents fait références aux billets de
				p.sentence
					<span class='mask-right'/>
					<span class='mask-left'/>
					| banque américains, sur lequel on retrouve les 
				p.sentence
					<span class='mask-right'/>
					<span class='mask-left'/>
					| visages d'anciens présidents, aujourd'hui décédés.

				//- p {{translate('presentation.quote')}}
				//- p {{translate('presentation.asterix')}}

			.logo
				img(src="assets/images/logo-joey.png")
					

</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import $ from 'jquery'
	import { TweenMax } from 'gsap'
	import Scrollable from '../abstracts/scrollable'
	import Background from '../components/background.vue'
	import _ from 'lodash'
	import Globals from '~utils/Globals.js'
	
  @Component({
		name: 'Presentation',
		components: { Background }
	})

	class Presentation extends Scrollable {

		mounted () {

			super.mounted()

			this._dom ()
		}

		init () {
			super.init()

			
		}

		_dom () {
			const $masksLeft = this.$el.querySelectorAll('.mask-left')
			const $masksRight = this.$el.querySelectorAll('.mask-right')
			const $movable = this.$el.querySelector('.movable')
			const $sentence = this.$el.querySelectorAll('.sentence')	
		}

		initTimeline () {
			super.initTimeline()

			// DOMS
			const $masksLeft = this.$el.querySelectorAll('.mask-left')
			const $masksRight = this.$el.querySelectorAll('.mask-right')
			const $movable = this.$el.querySelector('.movable')
			const $sentence = this.$el.querySelectorAll('.sentence')
			const $logo = this.$el.querySelector('.logo')
			const $text = this.$el.querySelector('.intro-presentation-text')


			// RATIOS
			const ratioHalf = window.innerHeight*.5 / (this.OFFSET + window.innerHeight*.5)
			const ratioHalfOffset = (this.OFFSET*.5/(this.OFFSET+window.innerHeight*.5))
			

			this.tl.fromTo($text,ratioHalf,{y:-window.innerHeight*.2},{y:0, ease:Power0.easeNone},0)
			this.tl.fromTo($movable,(1-ratioHalf),{y:0},{y:this.OFFSET, ease:Power0.easeNone},ratioHalf)
			this.tl.fromTo($sentence[0],ratioHalf,{y:-60},{y:0, ease:Power0.easeNone},0)
			this.tl.fromTo($sentence[1],ratioHalf,{y:-40},{y:0, ease:Power0.easeNone},0)
			this.tl.fromTo($sentence[2],ratioHalf,{y:-20},{y:0, ease:Power0.easeNone},0)
			this.tl.fromTo($sentence[3],ratioHalf,{y:20},{y:0, ease:Power0.easeNone},0)
			this.tl.fromTo($sentence[4],ratioHalf,{y:40},{y:0, ease:Power0.easeNone},0)
			this.tl.fromTo($sentence[5],ratioHalf,{y:60},{y:0, ease:Power0.easeNone},0)

			for(let i = 0;i < 6; i++) {
				
				let maskLeft = $sentence[i].querySelector('.mask-left')
				let maskRight = $sentence[i].querySelector('.mask-right')

				if(i % 2 === 0){
					this.tl.set(maskLeft,{autoAlpha:0},0)
					this.tl.set(maskRight,{autoAlpha:1},0)
					this.tl.fromTo(maskRight,ratioHalf,{x:'0%'},{x:'100%',ease:Power3.easeOut},0)
					
					this.tl.set(maskRight,{autoAlpha:0},ratioHalf*.9)
					this.tl.set(maskLeft,{autoAlpha:1},ratioHalf*.9)
					
					this.tl.fromTo(maskLeft,ratioHalf,{x:'-100%'},{x:'0%'},ratioHalf*.9)
				}

				else{
					this.tl.set(maskRight,{autoAlpha:0},0)
					this.tl.set(maskLeft,{autoAlpha:1},0)
					this.tl.fromTo(maskLeft,ratioHalf,{x:'0%'},{x:'-100%',ease:Power3.easeOut},0)
					
					this.tl.set(maskLeft,{autoAlpha:0},ratioHalf*(.8 + i*.2/6))
					this.tl.set(maskRight,{autoAlpha:1},ratioHalf*(.8 + i*.2/6))
					
					this.tl.fromTo(maskRight,ratioHalf,{x:'100%'},{x:'0%'},ratioHalf*(.8 + i*.2/6))
				}

			}

			this.tl.fromTo($sentence,ratioHalf*.8,{opacity:1},{opacity:0, ease:Power0.easeNone},ratioHalf)
			this.tl.fromTo(this.$el,ratioHalfOffset,{backgroundColor:'#232323'},{backgroundColor:'#05006c'},ratioHalfOffset+ratioHalf)
			
			this.tl.fromTo([$masksRight],
				ratioHalfOffset,
				{backgroundImage:'linear-gradient(to left, #232323 75%, rgba(35,35,35,0)'},
				{backgroundImage:'linear-gradient(to left, #05006c 75%, rgba(0,0,0,0)'},
				ratioHalfOffset+ratioHalf
			)
			this.tl.fromTo([$masksLeft],
				ratioHalfOffset,
				{backgroundImage:'linear-gradient(to right, #232323 75%, rgba(35,35,35,0)'},
				{backgroundImage:'linear-gradient(to right, #05006c 75%, rgba(0,0,0,0)'},
				ratioHalfOffset+ratioHalf
			)
				
			this.tl.fromTo($logo,ratioHalfOffset*.5,{opacity:0},{opacity:1, ease:Power0.easeNone},ratioHalfOffset*.5+ratioHalf)
			this.tl.add(()=>{
				if(this.scroller && this.scroller.scroll.direction === 1) {
					this.$events.emit('header.in')
				}
			},this.OFFSET*.5/this.total)

		}

		raf (y) {
			super.raf(y)
		}

		_bind () {
			super._bind()
		}

		_resize () {
			super._resize()

			this.OFFSET = window.innerHeight * .8
			this.bounds.height = window.innerHeight + this.OFFSET
			this.$el.style.height = this.bounds.height + "px"
			

			this.boundsAnim = {
				top: this.bounds.top - window.innerHeight*.5,
				bottom: this.bounds.top + this.OFFSET
			}
			this.total = this.boundsAnim.bottom - this.boundsAnim.top

			this.initTimeline()
		}

		_on () {
			super._on()
		}

		_off () {
			super._off()
		}

	}

	export default Presentation

</script>


<style lang="stylus">
	
	@import '../theme/utils'
	@import '../theme/variables'
	
	.intro-presentation
		width 100%
		height 100vh
		background #232323
		// padding-top 25vh

		.background
			z-index 100

		+break(xs)
			padding-left 30px
			padding-right 30px


		.gradient-layer
			height 100vh
			width 100%
			position absolute
			top 0
			left 0
			background linear-gradient(to bottom,#232323,$COLOR_BLUE)

		&-wrapper
			height 100vh
			width 100%
			flex-full-centerer()
			position relative

			.intro-presentation-text
				// position absolute
				max-width 640px
				text-align center
				top 0
				will-change transform
				position relative
				z-index 50

				+break(minlg)
					max-width 40vw

				+break(xs)
					padding 0 20px

				.separator
					margin 20px 0
					width 100%
					height 1px

				p
					// font-family $FONT_SECONDARY
					color #fff
					text-transform uppercase
					font-weight 700
					// margin 30px 0
					font-size em(18px)
					line-height em(21px,15px)
					letter-spacing .15em
					position relative
					will-change transform

					.mask-left,
					.mask-right
						position absolute
						top 0
						height 100%
						width calc(100% + 15vw)
						// opacity 0

					.mask-right
						right 0
						background-image linear-gradient(to left, #232323 75%, rgba(#232323,0))

					.mask-left
						left 0
						background-image linear-gradient(to right, #232323 75%, rgba(#232323,0))

					+break(xs)
						font-size 12px

			.logo
				max-width 290px
				width 100%
				position absolute
				top 50%
				left 50%
				transform translate3d(-50%,-50%,0)
				opacity 0
				z-index 60
				// display none

				+break(minlg)
					max-width 400px

				+break(xs)
					max-width 250px

				img
					width 100%



</style>


// WEBPACK FOOTER //
// presentation.vue?7acb40ce